import React from "react";

// Kit action tile: icon over a short label, for a row of options in a sheet
// (share sheet: share link, post story, copy link, QR code). Styles: .inyc-action-tile in src/styles/kit-controls.css.
const ActionTile = ({ icon, children, type = "button", className = "", ...rest }) => (
  <button type={type} className={`inyc-action-tile ${className}`.trim()} {...rest}>
    {React.isValidElement(icon) && icon.props.size == null ? React.cloneElement(icon, { size: 16 }) : icon}
    <span>{children}</span>
  </button>
);

export default ActionTile;
